exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.metric-card .card-header {\n    background-color: #fafafa;\n}\n", ""]);

// exports
